import {
  RightPanelContentStore,
  useRightPanelContentStore
} from '@components/right-panel/right-panel-content/right-panel-content-store'
import {MessageLinksData, MessageUtils} from '@extensions/message-utils'

type RetType = (e: React.MouseEvent<HTMLDivElement>) => void

export const getNodeName = (el: HTMLElement): string => {
  return (el.nodeName || '').toLocaleLowerCase()
}

export const useOnObjectsClick = (edit: boolean): RetType => {
  const [, rightPanelStore] = useRightPanelContentStore()

  const onClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    const el = e.target as HTMLElement

    const nodeName = getNodeName(el)

    if (nodeName === 'a' && edit) {
      e.preventDefault()
      return
    }

    if (edit) {
      return
    }

    processOnClickOnImage({el, nodeName, rightPanelStore, e})
  }

  return onClick
}

type ProcessOnClickOnImageProps = {
  el: HTMLElement
  nodeName: string
  rightPanelStore: RightPanelContentStore
  e: React.MouseEvent<HTMLDivElement>
}

const processOnClickOnImage = (props: ProcessOnClickOnImageProps): void => {
  const {el, nodeName, rightPanelStore, e} = props
  if (!el || nodeName !== 'img') {
    return
  }

  const linkRaw = el.getAttribute('src')
  const userDataFilePath = '/user-data/'
  if (!linkRaw.includes(userDataFilePath)) {
    return
  }

  const link = getPathWithoutPreview(linkRaw)

  const links: MessageLinksData[] = [{urls: [link], timestamp: 0}]
  rightPanelStore.setSelectedFilesToView(
    MessageUtils.getFileViewData(links),
    MessageUtils.getLinkIndex(links, link)
  )

  e.preventDefault()
}

// convert xxx.png-256-preview@178x256.png to xxx.png
export const getPathWithoutPreview = (path: string): string => {
  const pathArr = path.split('/')
  const fileName = pathArr.pop()
  if (!fileName.includes('preview')) {
    return path
  }

  const ext = getExtension(fileName)
  const [realFileName] = fileName.split(`.${ext}`)
  const realFileNameWithExt = `${realFileName}.${ext}`

  return [...pathArr, realFileNameWithExt].join('/')
}

const getExtension = (fileName: string): string => {
  return fileName.split('.').pop()
}
